import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import {
  Box,
  Button,
  FormControlLabel,
  Link,
  Modal,
  Radio,
  RadioGroup,
  Tooltip,
} from "@mui/material";
import SelectDropdown from "../../../Supporting files/SelectDropdown/SelectDropdown";
import './TasksSection.scss';

function TasksSection() {
  const navigate = useNavigate();
  const [tableData, setTableData] = React.useState([
    {
      title: "Started",
      title_class: "green",
      data: [
        {
          open_status: false,
          title: "Follow Up",
          status: "started",
          due_date: "31 Dec",
          priority: "High",
          priority_class: "high",
          linked_to: "Quotes-QT25",
          assignee: ["U", "R"],
          creation_date: "23 Dec",
          creation_time: "17:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
        {
          open_status: false,
          title: "Follow Up",
          status: "inqueue",
          due_date: "28 Dec",
          priority: "Low",
          priority_class: "low",
          linked_to: "Quotes-QT28",
          assignee: ["U", "R"],
          creation_date: "10 Dec",
          creation_time: "13:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
        {
          open_status: false,
          title: "Follow Up",
          status: "completed",
          due_date: "25 Dec",
          priority: "Highest",
          priority_class: "highest",
          linked_to: "Quotes-QT23",
          assignee: ["U", "R"],
          creation_date: "3 Dec",
          creation_time: "19:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
      ],
    },
  ]);
  const [warnTitle, setWarnTitle] = React.useState<boolean>(false);
  const [warnFirstName, setWarnFirstName] = React.useState<boolean>(false);
  const [warnLastName, setWarnLastName] = React.useState<boolean>(false);
  const [warnOrgName, setWarnOrgName] = React.useState<boolean>(false);
  const [warnPhone, setWarnPhone] = React.useState<boolean>(false);
  const [warnOrgEmail, setWarnOrgEmail] = React.useState<boolean>(false);
  const [viewTabsStatus, setViewTabsStatus] = React.useState("overview");
  const [openEmail, setOpenEmail] = React.useState(false);
  const [fullName, setFullName] = React.useState("Rahul Raghuvanshi");
  const [organizationName, setOrganizationName] = React.useState("Evervent");
  const [orgEmail, setOrgEmail] = React.useState("hello@evervent.in");
  const [personalemail, setPersonalEmail] = React.useState(
    "Kartike.kakkar@evervent.in"
  );
  const [spoc, setSpoc] = React.useState("");
  const [phoneNumber, setPhoneNumber] = React.useState("0122-65456486");
  const [mobilenumber, setMobileNumber] = React.useState("8965455451");
  const [Currentjob, setCurrentJob] = React.useState("Asso. Developer");
  const [Currentemployer, setCurrentEmployer] = React.useState("Evervent");
  const [title, setTitle] = React.useState("Mr.");
  const [firstName, setFirstName] = React.useState("kartike");
  const [lastName, setLastName] = React.useState("kakkar");
  const [Department, setDepartment] = React.useState("FrontEnd");
  const [Designation, setDesignation] = React.useState(
    "Ass. Frontend Developer"
  );
  const [Dob, setDob] = React.useState<Date | null>(new Date());
  const [gender, setGender] = React.useState("Male");
  const [personalMobile, setPersonalMobile] = React.useState("9897854825");
  const [buildingName, setBuildingName] = React.useState("Next57,341,phase 9");
  const [areaName, setAreaName] = React.useState("Industrial Area");
  const [country, setCountry] = React.useState("India");
  const [State, setState] = React.useState("Punjab");
  const [StateOrg, setStateOrg] = React.useState("Punjab");
  const [City, setCity] = React.useState("Mohali");
  const [CityOrg, setCityOrg] = React.useState("Mohali");
  const [Zipcode, setZipcode] = React.useState("160062");
  const [ZipcodeOrg, setZipcodeOrg] = React.useState("160062");
  const [industry, setIndustry] = React.useState("I.T.");
  const [streetName, setStreetName] = React.useState("Gandhi Street");
  const [subindustry, setSubIndustry] = React.useState("Degsign");
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const [removeStatus, setRemoveStatus] = React.useState(false);
  const [clientId, setClientId] = React.useState("EV1401");
  const [toggle, setToggle] = React.useState(true);
  const [uploadFile, setUploadFile] = React.useState(false);
  const [listViewStatus, setListViewStatus] = React.useState(true);
  const [expanded, setExpanded] = React.useState<string | false>("panel1");
  const [priorityStatus, setPriorityStatus] = React.useState("Pending");
  const [sectionStatus, SetSectionStatus] = React.useState<string>("personalDetails");
  const [subSection, setSubSection] = React.useState("businesscard");
  const [postQueryForm, setPostQueryForm] = React.useState(false);
  const title_data = [
    { key: "Mr.", value: "Mr." },
    { key: "Mrs.", value: "Mrs." },
    { key: "Ms.", value: "Ms." },
  ];
  const clientId_data = [
    { label: "EV101", value: "EV101" },
    { label: "EV120", value: "EV120" },
    { label: "EV201", value: "EV201" },
  ];
  const gender_data = [
    { key: "Male", value: "Male" },
    { key: "Female", value: "Female" },
  ];
  const disposition_table = [
    {
      sender_name: "Rahul Raghuvanshi",
      subject: "Automation Enhancements and ...",
      Cc_Bcc: "Umessh Gemini, Rohit Mankotia",
      Date_time: "30 Nov, 2022",
      time: "11:00 A.M.",
      attatchment: "",
    },
    {
      sender_name: "Rahul Raghuvanshi",
      subject: "Automation Enhancements and ...",
      Cc_Bcc: "Umessh Gemini, Kartike Kakkar",
      Date_time: "30 Nov, 2022",
      time: "11:00 A.M.",
      attatchment: "",
    },
  ];
  const industry_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const subindustry_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const ClientIds_data = [
    { label: "CL 0001", value: "CL 0001" },
    { label: "CL 0002", value: "CL 0002" },
    { label: "CL 0003", value: "CL 0003" },
    { label: "CL 0004", value: "CL 0004" },
    { label: "CL 0005", value: "CL 0005" },
    { label: "CL 0006", value: "CL 0006" },
  ];
  const attatchment_table_data = [
    {
      file_name: "621c94f41153e1835257b41b_lead mockup.webp",
      Date_time: "30 Nov, 2022",
      time: "11:00 A.M.",
    },
    {
      file_name: "621c94f41153e1835257b41b_lead mockup.webp",
      Date_time: "30 Nov, 2022",
      time: "11:00 A.M.",
    },
  ];
  const prioritystatusData = [
    { key: "Pending", value: "Pending" },
    { key: "Expired", value: "Expired" },
    { key: "Active", value: "Active" },
    { key: "Rejected", value: "Rejected" },
    { key: "Inprogress", value: "Inprogress" },
  ];
  const to_do_table_data = [
    {
      started_task: "Claim setterment follow up",
      due_date: "30 Nov,2022",
      priority_type: "Highest",
      linked_to: "Quotes",
      assignee: "",
      creation_time: "17:00 hrs",
      creation_date: "21-04-2011",
    },
    {
      started_task: "Claim setterment follow up",
      due_date: "30 Nov,2022",
      priority_type: "Highest",
      linked_to: "Quotes",
      assignee: "",
      creation_time: "17:00 hrs",
      creation_date: "21-04-2011",
    },
  ];
  const Department_data = [
    { label: "Engineering", value: "Engineering" },
    { label: "IT", value: "IT" },
    { label: "Human Resource", value: "Human Resource" },
    { label: "Business Development", value: "Business Development" },
    { label: "Designing", value: "Designing" },
    { label: "Management", value: "Management" },
  ];
  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
    { label: "New Zealand", value: "New Zealand" },
    { label: " South Africa", value: "South Africa" },
  ];
  const Designation_data = [
    {
      label: "Associate Frontend Developer",
      value: "Associate Frontend Developer",
    },
    { label: "Frontend Developer", value: "Frontend Developer" },
    { label: "Senior Frontend Developer", value: "Senior Frontend Developer" },
    {
      label: "Associate Software Engineer",
      value: "Associate Software Engineer",
    },
    { label: "Software Engineer", value: "Software Engineer" },
    { label: "Associate Hr", value: "Associate Hr" },
    { label: "Hr Executive", value: "Hr Executive" },
  ];
  const state_data = [
    { label: "Rajasthan", value: "Rajasthan" },
    { label: "Punjab", value: "Punjab" },
    { label: "Haryana", value: "Haryana" },
    { label: "Kerla", value: "Kerla" },
    { label: "Delhi", value: "Delhi" },
  ];
  const city_data = [
    { label: "Ambala", value: "Ambala" },
    { label: "Nanital", value: "Nanital" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Jaipur", value: "Jaipur" },
    { label: " New Delhi", value: "New Delhi" },
  ];
  const ClientId_data = [
    { label: "CL 0001", value: "CL 0001" },
    { label: "CL 0002", value: "CL 0002" },
    { label: "CL 0003", value: "CL 0003" },
    { label: "CL 0004", value: "CL 0004" },
    { label: "CL 0005", value: "CL 0005" },
    { label: "CL 0006", value: "CL 0006" },
  ];
  const handleClicked = () => {
    setToggle(true);
  };
  const handleClick = () => {
    setToggle(false);
  };
  // const updateMasterState = (
  //   attrName: any,
  //   value: string | boolean | number
  // ) => {
  //   attrName(value);
  // };

  // for scrolling
  const personalDetails = useRef(null);
  const emaildetails = useRef(null);
  const attatchmentsdetails = useRef(null);
  const tododetails = useRef(null);
  //const ref = useRef(null);
  const businesscard = useRef(null);
  const professional = useRef(null);
  const personaladdress = useRef(null);

  const scrollToSection = (elementRef: any) => {
    // debugger;
    elementRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleClicks = (ref: any) => {
    console.log("handle click", ref);
    ref.current?.scrollIntoView({ behavior: "smooth" });
  };

  //Table Data
  const [data, setData] = React.useState<
    Array<{
      title: string;
      title_class: string;
      data: Array<{
        open_status: boolean;
        title: string;
        status: string;
        due_date: string;
        priority: string;
        priority_class: string;
        linked_to: string;
        assignee: Array<string>;
        creation_date: string;
        creation_time: string;
        sub_data: Array<{
          title: string;
          status: string;
          due_date: string;
          priority: string;
          priority_class: string;
          linked_to: string;
          assignee: Array<string>;
          creation_date: string;
          creation_time: string;
        }>;
      }>;
    }>
  >([
    {
      title: "Started",
      title_class: "green",
      data: [
        {
          open_status: false,
          title: "Follow Up",
          status: "started",
          due_date: "31 Dec",
          priority: "High",
          priority_class: "high",
          linked_to: "Quotes-QT25",
          assignee: ["U", "R"],
          creation_date: "23 Dec",
          creation_time: "17:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
        {
          open_status: false,
          title: "Follow Up",
          status: "inqueue",
          due_date: "28 Dec",
          priority: "Low",
          priority_class: "low",
          linked_to: "Quotes-QT28",
          assignee: ["U", "R"],
          creation_date: "10 Dec",
          creation_time: "13:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
        {
          open_status: false,
          title: "Follow Up",
          status: "completed",
          due_date: "25 Dec",
          priority: "Highest",
          priority_class: "highest",
          linked_to: "Quotes-QT23",
          assignee: ["U", "R"],
          creation_date: "3 Dec",
          creation_time: "19:00",
          sub_data: [
            {
              title: "Second Call",
              status: "inqueue",
              due_date: "25 Nov",
              priority: "Highest",
              priority_class: "highest",
              linked_to: "Quotes-QT25",
              assignee: ["U", "R"],
              creation_date: "28 Dec",
              creation_time: "13:00",
            },
            {
              title: "Final Call",
              status: "completed",
              due_date: "20 Dec",
              priority: "Low",
              priority_class: "low",
              linked_to: "Quotes-QT28",
              assignee: ["U", "R"],
              creation_date: "20 Dec",
              creation_time: "15:00",
            },
            {
              title: "Follow Up",
              status: "inqueue",
              due_date: "31 Dec",
              priority: "Normal",
              priority_class: "normal",
              linked_to: "Quotes-QT24",
              assignee: ["U", "R"],
              creation_date: "26 Dec",
              creation_time: "19:00",
            },
          ],
        },
      ],
    },
  ]);

  

  const updateMasterState = (attrName: any, value: string) => {
    if (attrName[0] === "data") {
      let index = attrName[1];
      let sub_index = attrName[2];

      let parsed_data = data;
      parsed_data[index].data[sub_index].status = value;

      setData(parsed_data);
    } else if (attrName[0] === "sub_data") {
      let index = attrName[1];
      let sub_index = attrName[2];
      let sub_sub_index = attrName[3];

      let parsed_data = data;
      parsed_data[index].data[sub_index].sub_data[sub_sub_index].status = value;

      setData(parsed_data);
    } else {
      attrName(value);
    }

    console.log(attrName, value);
  };

  const changeSubDataStatus = (index: number, index_data: number) => {
    let parsed_data = data;

    parsed_data[index].data[index_data].open_status =
      !parsed_data[index].data[index_data].open_status;

    setData(parsed_data);
  };

  const statusData = [
    { key: "started", value: "Started" },
    { key: "inqueue", value: "In Queue" },
    { key: "senttoinsurer", value: "Sent to Insurer" },
    { key: "upcomingrenewal", value: "Upcoming Renewal" },
    { key: "pendingwithinsurer", value: "Pending with Insurer" },
    { key: "endorsementrequestsent", value: "Endorsement Request Sent" },
    { key: "claimrequestsent", value: "Claim Request Sent" },
    { key: "completed", value: "Completed" },
  ];

  const sortByStatus = (index: number) => {
    let parsed_data: Array<{
      title: string;
      title_class: string;
      data: Array<{
        open_status: boolean;
        title: string;
        status: string;
        due_date: string;
        priority: string;
        priority_class: string;
        linked_to: string;
        assignee: Array<string>;
        creation_date: string;
        creation_time: string;
        sub_data: Array<{
          title: string;
          status: string;
          due_date: string;
          priority: string;
          priority_class: string;
          linked_to: string;
          assignee: Array<string>;
          creation_date: string;
          creation_time: string;
        }>;
      }>;
    }> = data;

    parsed_data[index].data.sort(function (a, b) {
      if (a.status < b.status) {
        return -1;
      }
      if (a.status > b.status) {
        return 1;
      }
      return 0;
    });

    setData(parsed_data);
  };

  const sortByPriority = (index: number) => {
    let parsed_data: Array<{
      title: string;
      title_class: string;
      data: Array<{
        open_status: boolean;
        title: string;
        status: string;
        due_date: string;
        priority: string;
        priority_class: string;
        linked_to: string;
        assignee: Array<string>;
        creation_date: string;
        creation_time: string;
        sub_data: Array<{
          title: string;
          status: string;
          due_date: string;
          priority: string;
          priority_class: string;
          linked_to: string;
          assignee: Array<string>;
          creation_date: string;
          creation_time: string;
        }>;
      }>;
    }> = data;

    parsed_data[index].data.sort(function (a, b) {
      if (a.status < b.status) {
        return -1;
      }
      if (a.status > b.status) {
        return 1;
      }
      return 0;
    });

    setData(parsed_data);
  };

  const dueDate = (index: number) => {
    let parsed_data: Array<{
      title: string;
      title_class: string;
      data: Array<{
        open_status: boolean;
        title: string;
        status: string;
        due_date: string;
        priority: string;
        priority_class: string;
        linked_to: string;
        assignee: Array<string>;
        creation_date: string;
        creation_time: string;
        sub_data: Array<{
          title: string;
          status: string;
          due_date: string;
          priority: string;
          priority_class: string;
          linked_to: string;
          assignee: Array<string>;
          creation_date: string;
          creation_time: string;
        }>;
      }>;
    }> = data;

    parsed_data[index].data.sort(function (a, b) {
      if (a.status < b.status) {
        return -1;
      }
      if (a.status > b.status) {
        return 1;
      }
      return 0;
    });

    setData(parsed_data);
  };

  const linkedTo = (index: number) => {
    let parsed_data: Array<{
      title: string;
      title_class: string;
      data: Array<{
        open_status: boolean;
        title: string;
        status: string;
        due_date: string;
        priority: string;
        priority_class: string;
        linked_to: string;
        assignee: Array<string>;
        creation_date: string;
        creation_time: string;
        sub_data: Array<{
          title: string;
          status: string;
          due_date: string;
          priority: string;
          priority_class: string;
          linked_to: string;
          assignee: Array<string>;
          creation_date: string;
          creation_time: string;
        }>;
      }>;
    }> = data;

    parsed_data[index].data.sort(function (a, b) {
      if (a.status < b.status) {
        return -1;
      }
      if (a.status > b.status) {
        return 1;
      }
      return 0;
    });

    setData(parsed_data);
  };

  const assignee = (index: number) => {
    let parsed_data: Array<{
      title: string;
      title_class: string;
      data: Array<{
        open_status: boolean;
        title: string;
        status: string;
        due_date: string;
        priority: string;
        priority_class: string;
        linked_to: string;
        assignee: Array<string>;
        creation_date: string;
        creation_time: string;
        sub_data: Array<{
          title: string;
          status: string;
          due_date: string;
          priority: string;
          priority_class: string;
          linked_to: string;
          assignee: Array<string>;
          creation_date: string;
          creation_time: string;
        }>;
      }>;
    }> = data;

    parsed_data[index].data.sort(function (a, b) {
      if (a.status < b.status) {
        return -1;
      }
      if (a.status > b.status) {
        return 1;
      }
      return 0;
    });

    setData(parsed_data);
  };

  const creationDate = (index: number) => {
    let parsed_data: Array<{
      title: string;
      title_class: string;
      data: Array<{
        open_status: boolean;
        title: string;
        status: string;
        due_date: string;
        priority: string;
        priority_class: string;
        linked_to: string;
        assignee: Array<string>;
        creation_date: string;
        creation_time: string;
        sub_data: Array<{
          title: string;
          status: string;
          due_date: string;
          priority: string;
          priority_class: string;
          linked_to: string;
          assignee: Array<string>;
          creation_date: string;
          creation_time: string;
        }>;
      }>;
    }> = data;

    parsed_data[index].data.sort(function (a, b) {
      if (a.status < b.status) {
        return -1;
      }
      if (a.status > b.status) {
        return 1;
      }
      return 0;
    });

    setData(parsed_data);
  };

  const creationTime = (index: number) => {
    let parsed_data: Array<{
      title: string;
      title_class: string;
      data: Array<{
        open_status: boolean;
        title: string;
        status: string;
        due_date: string;
        priority: string;
        priority_class: string;
        linked_to: string;
        assignee: Array<string>;
        creation_date: string;
        creation_time: string;
        sub_data: Array<{
          title: string;
          status: string;
          due_date: string;
          priority: string;
          priority_class: string;
          linked_to: string;
          assignee: Array<string>;
          creation_date: string;
          creation_time: string;
        }>;
      }>;
    }> = data;

    parsed_data[index].data.sort(function (a, b) {
      if (a.status < b.status) {
        return -1;
      }
      if (a.status > b.status) {
        return 1;
      }
      return 0;
    });

    setData(parsed_data);
  };
  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };


    return (
        <Grid container spacing={3}>
            {data.map((item, index) => (
                <Grid
                    xs={12}
                    sx={{ padding: "12px 0px" }}
                    className="TaskListsection">
                    <div className="task_list">
                        <ul className="heading">
                            <li>
                                <p
                                    className={
                                        "started_heading " + item.title_class
                                    }>
                                    {item.title}
                                </p>
                            </li>
                            <li>
                                Status
                                <button
                                    className="sorting-btn"
                                    onClick={() => {
                                        sortByStatus(index);
                                    }}>
                                    <img
                                        src="./images/sorting_btn.svg"
                                        alt=""
                                    />
                                </button>
                            </li>

                            <li>
                                Due Date
                                <button
                                    className="sorting-btn"
                                    onClick={() => {
                                        dueDate(index);
                                    }}>
                                    <img
                                        src="./images/sorting_btn.svg"
                                        alt=""
                                    />
                                </button>
                            </li>

                            <li>
                                Priority
                                <button
                                    className="sorting-btn"
                                    onClick={() => {
                                        sortByPriority(index);
                                    }}>
                                    <img
                                        src="./images/sorting_btn.svg"
                                        alt=""
                                    />
                                </button>
                            </li>

                            <li>
                                Linked To
                                <button
                                    className="sorting-btn"
                                    onClick={() => {
                                        linkedTo(index);
                                    }}>
                                    <img
                                        src="./images/sorting_btn.svg"
                                        alt=""
                                    />
                                </button>
                            </li>

                            <li>
                                Assignee
                                <button
                                    className="sorting-btn"
                                    onClick={() => {
                                        assignee(index);
                                    }}>
                                    <img
                                        src="./images/sorting_btn.svg"
                                        alt=""
                                    />
                                </button>
                            </li>

                            <li>
                                Creation Date
                                <button
                                    className="sorting-btn"
                                    onClick={() => {
                                        creationDate(index);
                                    }}>
                                    <img
                                        src="./images/sorting_btn.svg"
                                        alt=""
                                    />
                                </button>
                            </li>

                            <li>
                                Creation Time
                                <button
                                    className="sorting-btn"
                                    onClick={() => {
                                        creationTime(index);
                                    }}>
                                    <img
                                        src="./images/sorting_btn.svg"
                                        alt=""
                                    />
                                </button>
                            </li>
                        </ul>
                    </div>
                    <div className="task_list mb-2">
                        <div className="sub_heading">
                            {item.data.map((data, sub_index) => (
                                <ul className="sub_sub_heading">
                                    <li
                                    // onClick={() => {
                                    //   navigate("/TaskDetail");
                                    // }}
                                    >
                                        <button
                                            className="table_right_arrow"
                                            onClick={() => {
                                                changeSubDataStatus(
                                                    index,
                                                    sub_index
                                                );
                                            }}>
                                            <img
                                                className={
                                                    data.open_status == true
                                                        ? "rotate_icon"
                                                        : ""
                                                }
                                                src="./images/table_right_arrow.svg"
                                                alt=""
                                            />
                                        </button>
                                        <span
                                            onClick={() => {
                                                navigate("/TaskDetail");
                                            }}>
                                            {data.title}
                                        </span>
                                    </li>
                                    <li id={data.status}>
                                        <div className={"status_dropdown"}>
                                            <SelectDropdown
                                                class_name="inputFieldd"
                                                title=""
                                                value={data.status}
                                                attrName={[
                                                    "data",
                                                    index,
                                                    sub_index,
                                                ]}
                                                value_update={updateMasterState}
                                                dropdown_data={statusData}
                                                warn_status={false}
                                            />
                                        </div>
                                    </li>
                                    <li>{data.due_date}</li>
                                    <li>
                                        <span
                                            className={
                                                "priority " + data.priority_class
                                            }>
                                            {data.priority}
                                        </span>
                                    </li>
                                    <li>{data.linked_to}</li>
                                    <li>
                                        <Tooltip title="Udit">
                                            <span className="asignee_tag orgBg">
                                                U
                                            </span>
                                        </Tooltip>

                                        <Tooltip title="Rahul">
                                            <span className="asignee_tag violetBg">
                                                R
                                            </span>
                                        </Tooltip>
                                    </li>
                                    <li>{data.creation_date}</li>
                                    <li>{data.creation_time}</li>
                                    {/* Sub Data Start */}
                                    {data.open_status == true ? (
                                        <>
                                            {data.sub_data.map(
                                                (sub_data, iindex) => (
                                                    <ul className="sub_category">
                                                        <li>
                                                            <button className="table_right_arrow">
                                                                <img
                                                                    src="./images/table_right_arrow.svg"
                                                                    alt=""
                                                                />
                                                            </button>
                                                            {sub_data.title}
                                                        </li>
                                                        <li id={sub_data.status}>
                                                            <div
                                                                className={
                                                                    " status_dropdown"
                                                                }>
                                                                <SelectDropdown
                                                                    class_name="inputFieldd"
                                                                    title=""
                                                                    value={sub_data.status}
                                                                    attrName={[
                                                                        "sub_data",
                                                                        index,
                                                                        sub_index,
                                                                        iindex,
                                                                    ]}
                                                                    value_update={
                                                                        updateMasterState
                                                                    }
                                                                    dropdown_data={statusData}
                                                                    warn_status={false}
                                                                />
                                                            </div>
                                                        </li>
                                                        <li>{sub_data.due_date}</li>
                                                        <li>
                                                            <span
                                                                className={
                                                                    "priority " +
                                                                    sub_data.priority_class
                                                                }>
                                                                {sub_data.priority}
                                                            </span>
                                                        </li>
                                                        <li>{sub_data.linked_to}</li>
                                                        <li>
                                                            <Tooltip title="Udit">
                                                                <span className="asignee_tag orgBg">
                                                                    U
                                                                </span>
                                                            </Tooltip>

                                                            <Tooltip title="Rahul">
                                                                <span className="asignee_tag violetBg">
                                                                    R
                                                                </span>
                                                            </Tooltip>
                                                        </li>
                                                        <li>
                                                            {sub_data.creation_date}
                                                        </li>
                                                        <li>
                                                            {sub_data.creation_time}
                                                        </li>
                                                    </ul>
                                                )
                                            )}
                                        </>
                                    ) : null}
                                    {/* Sub Data End */}
                                </ul>
                            ))}
                        </div>
                    </div>
                </Grid>
            ))}
        </Grid>
    )
}

export default TasksSection